export const defaultCookieConsentName = "CookieConsent";
export const POSITION_OPTIONS = {
    TOP: "top",
    BOTTOM: "bottom",
    NONE: "none",
};
export const SAME_SITE_OPTIONS ={
    STRICT: "strict",
    LAX: "lax",
    NONE: "none",
}
export const VISIBILITY_OPTIONS = {
    HIDDEN: "hidden",
    SHOW: "show",
    BY_COOKIE_VALUE: "byCookieValue",
};
